// Marketplace URL-filter helpers — extracted from
// `marketplace/functions/index.js` so canvas's /marketplace deep-link
// surface and the marketplace sub-app pull from one source. Both call
// sites previously cross-imported across packages, which violated the
// Phase 10 no-restricted-imports rule.
//
// `parseFiltersFromSearch(searchString)` returns a partial diff to apply
// to the host root state — only keys that appear in the URL and pass the
// allowed-set guards are present in the output.

const _URL_ALLOWED_KINDS = ['library', 'template', 'integration', 'registrar', 'plugin', 'mcp', 'all']
const _URL_ALLOWED_PRICING = ['all', 'free', 'paid', 'installed', 'pinned']
const _URL_ALLOWED_SORTS = ['name', 'priceAsc', 'priceDesc']

export const URL_ALLOWED_KINDS = _URL_ALLOWED_KINDS
export const URL_ALLOWED_PRICING = _URL_ALLOWED_PRICING
export const URL_ALLOWED_SORTS = _URL_ALLOWED_SORTS

// Parse location.search (or any search string) → partial host state diff.
// Returns only keys present + allowed. The synthetic `_itemId` key carries
// the detail-open target for resolution against catalog by the caller.
export const parseFiltersFromSearch = (search) => {
  const sp = new URLSearchParams(search || '')
  const out = {}
  const kind = sp.get('kind')
  if (kind && _URL_ALLOWED_KINDS.includes(kind)) out.activeKind = kind
  const pricing = sp.get('pricing')
  if (pricing && _URL_ALLOWED_PRICING.includes(pricing)) out.activePricing = pricing
  const sort = sp.get('sort')
  if (sort && _URL_ALLOWED_SORTS.includes(sort)) out.activeSort = sort
  const q = sp.get('q')
  if (typeof q === 'string') out.query = q
  const cats = sp.get('categories')
  if (cats) {
    out.activeCategories = cats.split(',').map((c) => c.trim()).filter(Boolean)
  }
  const itemId = sp.get('item')
  if (itemId) out._itemId = itemId
  return out
}
